import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import i18n from '@/js/i18n/i18n';
import setupInterceptors from '@/js/services/setupInterceptors';

setupInterceptors(store);
createApp(App).use(store).use(i18n).use(router).mount('#app');
